import { Employee } from '../../model/api/administration/employee';
import { InvState } from '../../model/api/inventory/inv-state';
import { IEntity } from '../../model/i-entity';
import { GenericTableList } from './generic.table.list';

export class GenericPrimeNgDataTableList<T extends IEntity<V>, V> extends GenericTableList<T, V> {

    invStates: InvState[];
    // selectedInvStates: InvState[];

    public loadData(event: any) {
        // event.first = First row offset
        // event.rows = Number of rows per page
        // event.sortField = Field name to sort in single sort mode
        // event.sortOrder = Sort order as number, 1 for asc and -1 for dec in single sort mode
        // multiSortMeta: An array of SortMeta objects used in multiple columns sorting. Each SortMeta has field and order properties.
        // filters: Filters object having field as key and filter value, filter matchMode as value

        // let sortColumn: string = event.sortField === undefined ? this.sortColumn : event.sortField;

        this.invStates = [
            {id: 1, parentCode: '', mask: '', isDeleted: false, state: '', name: 'New York', code: 'NY'},
            {id: 1, parentCode: '', mask: '', isDeleted: false, state: '', name: 'Rome', code: 'RM'},
            {id: 1, parentCode: '', mask: '', isDeleted: false, state: '', name: 'London', code: 'LDN'},
            {id: 1, parentCode: '', mask: '', isDeleted: false, state: '', name: 'Istanbul', code: 'IST'},
            {id: 1, parentCode: '', mask: '', isDeleted: false, state: '', name: 'Paris', code: 'PRS'}
        ];


        let sortColumn = '';
        if (event.sortField === undefined) {
            sortColumn = this.sortColumn;
        } else {
            sortColumn = event.sortField;
            this.sortDirection = event.sortOrder === -1 ? 'desc' : 'asc';
        }

        let dotIndex = -1;
        dotIndex = sortColumn.lastIndexOf('.');
        // if (dotIndex >= 0) sortColumn = sortColumn.substring(dotIndex + 1);

        this.currentPage = (event.first / event.rows) + 1;
        this.pageSize = event.rows;
        this.sortColumn = sortColumn;

        // if (this.initialized)

        setTimeout(() => {
            this.refreshItems();
          }, 0);
    }

    paginate(event) {
        this.currentPage = event.first;
        this.pageSize = event.rows;
        this.refreshItems();
        console.log('currentPaginationPage = first: ' + this.currentPage + ' rows: ' + this.pageSize);
        }

        getValue(event: Event): string {
            return (event.target as HTMLInputElement).value;
          }
}
